import { render, staticRenderFns } from "./NavareaTable.vue?vue&type=template&id=87e21d7c&scoped=true&"
import script from "./NavareaTable.vue?vue&type=script&lang=js&"
export * from "./NavareaTable.vue?vue&type=script&lang=js&"
import style0 from "./NavareaTable.vue?vue&type=style&index=0&id=87e21d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e21d7c",
  null
  
)

export default component.exports